import {
    Component, Input, Output, EventEmitter, ViewChildren, AfterViewChecked
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { CgpConfirmationDialogService } from '../cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';

@Component({
    selector: 'cgp-form-dialog',
    templateUrl: './cgp-form-dialog.component.html',
    styleUrls: ['./cgp-form-dialog.component.scss']
})
export class CgpFormDialogComponent {
    // implements AfterViewChecked
    // @ViewChildren('input') vc;
    // ngAfterViewChecked(): void {
    //     if (this.active) this.focusFirst();
    // }
    sortableStyles = {
        empty: {
            'width': '100%',
            'line-height': '4em',
            'text-align': 'center',
            'border-radius': '4px',
            'border': '1px dashed #ccc',
            'background': '#fafafa',
        },
        active: {
            'border': '1px dashed #538FE3',
            'border-radius': '4px',
            'background-color': '#538FE3',
            'color': '#fff'
        },
    }
    constructor(private cgpConfirmationDialogService: CgpConfirmationDialogService,
        private cgpSnackbarService: CgpSnackbarService, ) { }

    active: boolean = false;
    customTitle: string;
    private isSearchHidden: boolean = false;

    @Input() isNew: boolean = false;
    @Input() title: string;
    @Input() formGroup: FormGroup;
    @Input() formControls: any[] = [];
    @Input() width: any;
    @Input() height: any;

    @Input() set model(obj: any) {
        if (obj) this.formGroup.reset(obj);
        this.active = obj !== undefined && obj !== null;
    }

    @Input()
    private set template(template: any) {
        this.active = template !== undefined && template !== null;

        if (template) {
            this.formGroup = template.editForm;
            this.formControls = template.formControls;
            this.title = template.title;
            this.isNew = template.isNew;
            this.customTitle = template.customTitle;
            this.filter = template.filter;
        }
    }

    filter: boolean;
    actionFormDialog: any = undefined;
    panelBarControlSelectedItem: any = undefined;
    isActionFormDialogNew: boolean = false;

    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() save: EventEmitter<any> = new EventEmitter();
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    private onSave(e): void {
        e.preventDefault();
        this.save.emit(this.formGroup.value);
        this.active = false;
        this.isSearchHidden = false;
    }

    private resetFilters() {
        try {
            for (let c of this.formControls) {
                if (c.service) {
                    c.service.resetFilter();
                }
            }
        } catch (e) { }
    }

    private onCancel(e): void {
        e.preventDefault();
        this.resetFilters();
        this.closeForm();
    }


    private closeForm(): void {
        this.isSearchHidden = false;
        this.isInvalidUser = false;
        this.active = false;
        this.cancel.emit();
    }


    private isInvalidUser: boolean;
    private onSearch(e, control) {
        let node = e.target;

        if (e.type == 'click') node = node.parentNode.previousElementSibling;
        if (node.value == undefined) {
            node = e.target;
            node = node.parentNode.childNodes[0];
        }
        if (node.value) {
            let formControl = this.formGroup.get(control.name);
            this.isInvalidUser = false;
            control.service.getUserByGmin(node.value)
                .then(obj => {
                    if (obj) {
                        formControl.reset(node.value);
                        if (obj.body)
                        {
                            var formattedJSON = JSON.stringify(obj.body);
                            obj = JSON.parse(formattedJSON);
                        }
                        else
                            obj = JSON.parse(obj._body);
                        obj.IsActive = this.formGroup.value.IsActive;
                        obj.ModuleId = this.formGroup.value.ModuleId;
                        this.formGroup.reset(obj);
                        this.isSearchHidden = obj !== undefined;
                    } else {
                        throw new Error();
                    }
                })
                .catch(e => {
                    this.isInvalidUser = true;
                    this.formGroup.reset({ IsActive: this.formGroup.value.IsActive, ModuleId: this.formGroup.value.ModuleId });
                })
        }
    }

    private clearSearch(e, control) {
        this.formGroup.controls[control.name].reset();
        this.isSearchHidden = false;
    }

    private onPanelBarItemEdit(control, isNew) {
        if (control) {
            this.isActionFormDialogNew = isNew;
            this.actionFormDialog = control.editTemplate.formDialog;
            this.actionFormDialog.control = control;

            let dataItem = isNew ? undefined : this.panelBarControlSelectedItem;
            this.actionFormDialog.edit(dataItem);

        }
    }


    private actionFormSaveHandler(editDataItem) {
        if (!this.isActionFormDialogNew) editDataItem.id = this.panelBarControlSelectedItem.id;
        this.actionFormDialog.save(editDataItem, this.formGroup, this.isActionFormDialogNew);
        this.isActionFormDialogNew = false;
    }


    private actionFormCancelHandler() {
        this.actionFormDialog = undefined;
        this.isActionFormDialogNew = false;
    }


    private panelBarControlstateChange(dataItems: any[]) {
        this.panelBarControlSelectedItem = dataItems.find(item => item.selected);
    }


    private onPanelBarItemDelete(control, dataItem) {
        var self = this;
        this.cgpConfirmationDialogService.showConfirmationDialog({
            title: 'Delete Confirmation',
            message: 'Are you sure that you want to delete this record?',
            alert: 'danger',
            onYesClick: () => {
                control.editTemplate.formDialog.delete(dataItem);
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            },
            onNoClick: () => {
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            }
        });
    }

    private onDialogAction(control: any) {
        try {

            control.callback()
                .then(response => {
                    if (control.refresh) this.refresh.emit(true);
                    if (control.close) this.closeForm();
                });
        } catch (e) { }
    }

    // focusFirst() {
    //     try {
    //         try {
    //             this.vc.first.nativeElement.focus();
    //         } catch (e) {
    //             this.vc.first.focus()
    //         }
    //     } catch (e) { }
    // }
}
